window.cpap.onDocumentReady(() => {
  // 🚨 This is only for user-blocking logic. Nothing that is user-visible or background should be included here!
  // @see https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API#task_priorities
  window.scheduler.postTask(
    () => {
      const openProductShowcaseFlyoutOnClick = () => {
        document.querySelectorAll('.cpap__flyout-product-showcase-button').forEach((node) => {
          const learnMoreButtonNode = document.querySelector('.btn-learn-more');

          node.addEventListener('click', (event) => {
            event.preventDefault();

            window.cpap.dynamicallyLoadScript(window.cpap.cdnSources.cpapProductFormJs);
            window.cpap.dynamicallyLoadScript(window.cpap.cdnSources.cpapProductVariantPickerJs);

            window.cpap.openFlyout('.cpap__flyout-product-showcase');

            if (learnMoreButtonNode && node.classList.contains('rx-required-btn')) {
              learnMoreButtonNode.click();
            }
          });
        });
      };

      openProductShowcaseFlyoutOnClick();
      // 👇 This will be used to re-initialize after a user-driven variant change event on the PDP pages.
      window.cpap.openProductShowcaseFlyoutOnClick = openProductShowcaseFlyoutOnClick;
    },
    { priority: 'user-blocking' }
  );
});
